import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-root" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row flex-column-fluid" }
const _hoisted_3 = { class: "d-flex flex-column flex-lg-row-fluid py-10" }
const _hoisted_4 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_5 = { class: "w-lg-700px p-10 p-lg-15 mx-auto" }
const _hoisted_6 = { class: "mb-10" }
const _hoisted_7 = { class: "welcome-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Massive Bio", -1)
const _hoisted_9 = { class: "sign-in-area" }
const _hoisted_10 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_13 = { class: "position-relative mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "text-muted" }
const _hoisted_21 = { class: "fv-row mb-5" }
const _hoisted_22 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_23 = { class: "position-relative mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "text-lg-end mt-10" }
const _hoisted_31 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_32 = { class: "indicator-label" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/files/arrow-right.svg",
  class: "px-2"
}, null, -1)
const _hoisted_34 = { class: "indicator-progress" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthAside = _resolveComponent("AuthAside")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AuthAside),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              novalidate: "novalidate",
              onSubmit: _ctx.onChangePassword,
              id: "kt_login_signup_form",
              "validation-schema": _ctx.registration
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h1", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Welcome to")) + " ", 1),
                    _hoisted_8
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(" Reset Password")), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("New Password")), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid border-gray-300 password-input",
                        type: _ctx.visibility,
                        placeholder: _ctx.$t('Password'),
                        name: "password",
                        autocomplete: "off"
                      }, null, 8, ["type", "placeholder"]),
                      (_ctx.visibility === 'password')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPassword())),
                            style: {"position":"absolute","right":"20px","top":"10px","width":"auto","border":"unset","background-color":"unset"}
                          }, _hoisted_15))
                        : _createCommentVNode("", true),
                      (_ctx.visibility === 'text')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hidePassword())),
                            style: {"position":"absolute","right":"20px","top":"10px","width":"auto","border":"unset","background-color":"unset"}
                          }, _hoisted_17))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ErrorMessage, { name: "password" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(
                      "Use 12 or more characters with a mix of letters, numbers & symbols."
                    )), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("Confirm New Password")), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid border-gray-300 password-input",
                      type: _ctx.visibility_confirmation,
                      placeholder: "Confirm Password",
                      name: "password_confirmation",
                      autocomplete: "off"
                    }, null, 8, ["type"]),
                    (_ctx.visibility_confirmation === 'password')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPasswordConfirmation())),
                          style: {"position":"absolute","right":"20px","top":"10px","width":"auto","border":"unset","background-color":"unset"}
                        }, _hoisted_25))
                      : _createCommentVNode("", true),
                    (_ctx.visibility_confirmation === 'text')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hidePasswordConfirmation())),
                          style: {"position":"absolute","right":"20px","top":"10px","width":"auto","border":"unset","background-color":"unset"}
                        }, _hoisted_27))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Change Password")) + " ", 1),
                      _hoisted_33
                    ]),
                    _createElementVNode("span", _hoisted_34, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Please wait")) + "... ", 1),
                      _hoisted_35
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex flex-center flex-wrap fs-6 p-5 pb-0", { 'custom-mobile': _ctx.ismobile }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex-center fs-6 copyright", { 'ps-5 pe-5 font-8': _ctx.ismobile }])
          }, [
            _createVNode(_component_i18n_t, { keypath: "privacyPolicyText" }, {
              policy: _withCtx(() => [
                _createElementVNode("a", {
                  href: _ctx.privacyPolicyUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t("Privacy Policy")), 9, _hoisted_36)
              ]),
              terms: _withCtx(() => [
                _createElementVNode("a", {
                  href: _ctx.termsAndConditionsUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t("Terms & Conditions")), 9, _hoisted_37)
              ]),
              _: 1
            })
          ], 2)
        ], 2)
      ])
    ])
  ]))
}